import { useCallback, useMemo, useState }    from 'react';

import { FormPart }             from '@modules/shared/components/FormPart';
import { getOptions }           from '@shared/commonFunctions';
import { Modal }                from '@shared/components/modals/Modal';
import { SaveButton }           from '@shared/inputs/Buttons';
import { FlexEnd }              from '@styles/StyledDiv';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { INcicCodeResponse } from '../interfaces';

export interface INcicCodeModalProps {
  handleClose: (selectedNcicCode: string) => void;
  ncicCodes : INcicCodeResponse[];
  ncicCodesFieldName?: string;
  ncicCodeModalPosition: number;
}

export const NcicCodeModal = ({
  handleClose,
  ncicCodes,
  ncicCodesFieldName,
  ncicCodeModalPosition
}: INcicCodeModalProps) => {
  const [selectedNcicCode, setSelectedNcicCode] = useState('');
  const handleFormSubmit = () => {
    // Pass the selected value to the parent component before closing the modal
    handleClose(selectedNcicCode);
  };

  const handleCloseModal = useCallback(() => {
    // Call handleClose with an empty string when the modal is closed without selecting a value
    handleClose('');
  }, [handleClose]);

  const formConfig = useMemo(
    () => [
      
      {
        name: ncicCodesFieldName,
        label: '',
        options: getOptions(ncicCodes, 'makeCode', 'description'),
        nextLine: true,
        component: SelectAutocompleteField,
        width: '100%',
        onChange: (value: string) => setSelectedNcicCode(value),
      },
    ],
    [ncicCodes, ncicCodesFieldName],
  );

  return (
    <Modal 
      open
      hideBackdrop
      title="Please select Ncic code"
      dialogWidth="35vw" 
      resetPosition={ncicCodeModalPosition}
      onClose={handleCloseModal}
      >
        <FormPart config={formConfig} />

        <FlexEnd>
          <SaveButton
            type    = "button"
            label   = "Okay"
            onClick = {handleFormSubmit}
          />
        </FlexEnd>
    </Modal>
  );
};
